@if (valuesToShow.length > 0) {
  @if (columnTitle) {
    <div class="title">{{ columnTitle }}</div>
  }
  <div class="description" [ngClass]="{'is-column': columnTitle}">
    @if (!hideBullet && !columnTitle) {
      <mat-icon svgIcon="checkbox-marked-circle"></mat-icon>
    }
    <span>
      <ng-content select="[prefix]"></ng-content>
      @for (which of valuesToShow; track which) {
        <span [ngClass]="{'old-value': which === 'old', new: which === 'current' && isNew}">
          @for (prop of properties; track prop) {
            @if (value(prop, which)) {
              <span class="format-parts">
                @if (prop.valueFilter == 'size') {
                  <span [innerHtml]="applyFormat(prop.formatToken, value(prop, which) | size:'multichar' | inches)"></span>
                }
                @if (prop.valueFilter == 'currency') {
                  <span class="currency" [innerHtml]="applyFormat(prop.formatToken, value(prop, which) | currency2 )"></span>
                }
                @if (!prop.valueFilter) {
                  <span [innerHtml]="applyFormat(prop.formatToken, value(prop, which))"></span>
                }
              </span>
            }
          }
        </span>
      }
    </span>
  </div>
  <ng-content select="[after]"></ng-content>
}
